import {useIntl} from 'react-intl'

export default function useSearchFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        searchTerm: {
            name: `${prefix}searchTerm`,
            placeholder: formatMessage({
                defaultMessage: "I'm looking for ...",
                id: 'empty_cart.search_term.placeholder'
            }),
            type: 'text',
            defaultValue: '',
            error: errors[`${prefix}searchTerm`],
            inputProps: {
                autoComplete: 'search',
                variant: 'flushed'
            },
            control
        }
    }

    return fields
}
